// extracted by mini-css-extract-plugin
export var content = "_mn-1";
export var fullScreen = "_mn-0";